import React from 'react';

/**
 * Recital track / Audition (2026-09-27, build step 6), in the teacher's
 * transport for the file that is playing: a teacher chooses the cut by
 * listening to it. Recital is ONE file per student x song (choosing another
 * replaces it; the old one is kept in the entry's history); Audition can be
 * any number. Tapping a pressed control takes the mark off. Plain <button>s
 * with aria-pressed; the badge on the pill says the same thing at rest.
 */
const RoleButtons = ({ file, roles }) => {
	if (!file || !roles || !file.storagePath) return null;
	const role = roles.roleOf(file);
	return (
		<span className="tp__roles" role="group" aria-label="Use this track for">
			<button
				type="button"
				className={`tp__pill tp__rolebtn${role === 'recital' ? ' is-current' : ''}`}
				aria-pressed={role === 'recital'}
				onClick={() => roles.setRecital(file)}>
				<i className="fa-sharp fa-solid fa-star" aria-hidden="true" />
				{role === 'recital' ? 'Recital track' : 'Use for recital'}
			</button>
			<button
				type="button"
				className={`tp__pill tp__rolebtn${role === 'audition' ? ' is-current' : ''}`}
				aria-pressed={role === 'audition'}
				onClick={() => roles.toggleAudition(file)}>
				<i className="fa-sharp fa-solid fa-clipboard-check" aria-hidden="true" />
				{role === 'audition' ? 'Audition track' : 'Use for audition'}
			</button>
		</span>
	);
};

export default RoleButtons;
